import { useEffect, useState } from 'react';
import {
  applyXeroInvoicesRuntimeOverlay,
  describeXeroInvoicesConfig,
  subscribeXeroInvoicesRuntimeOverlay,
} from '../config/xeroInvoicesConfig';
import { subscribeXeroInvoicesUiFlags } from '../services/xeroInvoicesRuntimeFlagsService';

/**
 * Keeps xeroInvoicesConfig runtime overlay in sync with Firestore.
 * Re-renders subscribers when flags change.
 */
export function useXeroInvoicesRuntimeFlags() {
  const [, bump] = useState(0);

  useEffect(() => {
    const unsubOverlay = subscribeXeroInvoicesRuntimeOverlay(() => bump((n) => n + 1));
    const unsubFs = subscribeXeroInvoicesUiFlags(
      (flags) => applyXeroInvoicesRuntimeOverlay(flags),
      () => {
        applyXeroInvoicesRuntimeOverlay({
          killSwitch: false,
          exposeCustomerTools: true,
          exposeAdminTools: true,
          payNowOffersEnabled: false,
          payNowRules: [],
          payNowExcludedSkus: [],
        });
      }
    );
    return () => {
      unsubOverlay();
      unsubFs();
    };
  }, []);

  return describeXeroInvoicesConfig();
}
